'use client';

import { useAuthStore } from '@/stores/AuthStore';

//* 서버가 계산한 isGuest는 RSC 페이로드에 박혀 뒤로가기에서 갱신되지 않는다 — 클라 판정이 끝나면 그쪽이 진실이다.
export const useIsGuest = (serverIsGuest: boolean) => {
  const isLogin = useAuthStore((state) => state.isLogin);

  return isLogin === undefined ? serverIsGuest : !isLogin;
};
